var map = {
	"./accessories-0.svg": 306,
	"./accessories-1.svg": 307,
	"./accessories-2.svg": 308,
	"./accessories-3.svg": 309,
	"./clothes-0.svg": 310,
	"./clothes-1.svg": 311,
	"./clothes-2.svg": 312,
	"./clothes-3.svg": 313,
	"./clothes-4.svg": 314,
	"./clothes-5.svg": 315,
	"./clothes-6.svg": 316,
	"./clothes-7.svg": 317,
	"./clothes-8.svg": 318,
	"./clothes-9.svg": 319,
	"./face-0.svg": 320,
	"./face-1.svg": 321,
	"./face-2.svg": 322,
	"./face-3.svg": 323,
	"./face-4.svg": 324,
	"./hair-0-0.svg": 325,
	"./hair-0-1.svg": 326,
	"./hair-0-2.svg": 327,
	"./hair-0-3.svg": 328,
	"./hair-0-4.svg": 329,
	"./hair-0-5.svg": 330,
	"./hair-0-6.svg": 331,
	"./hair-0-7.svg": 332,
	"./hair-1-0.svg": 333,
	"./hair-1-1.svg": 334,
	"./hair-1-2.svg": 335,
	"./hair-1-3.svg": 336,
	"./hair-1-4.svg": 337,
	"./hair-1-5.svg": 338,
	"./hair-1-6.svg": 339,
	"./hair-1-7.svg": 340,
	"./hair-2-0.svg": 341,
	"./hair-2-1.svg": 342,
	"./hair-2-2.svg": 343,
	"./hair-2-3.svg": 344,
	"./hair-2-4.svg": 345,
	"./hair-2-5.svg": 346,
	"./hair-2-6.svg": 347,
	"./hair-2-7.svg": 348,
	"./hair-3-0.svg": 349,
	"./hair-3-1.svg": 350,
	"./hair-3-2.svg": 351,
	"./hair-3-3.svg": 352,
	"./hair-3-4.svg": 353,
	"./hair-3-5.svg": 354,
	"./hair-3-6.svg": 355,
	"./hair-3-7.svg": 356,
	"./hair-4-0.svg": 357,
	"./hair-4-1.svg": 358,
	"./hair-4-2.svg": 359,
	"./hair-4-3.svg": 360,
	"./hair-4-4.svg": 361,
	"./hair-4-5.svg": 362,
	"./hair-4-6.svg": 363,
	"./hair-4-7.svg": 364,
	"./hair-5-0.svg": 365,
	"./hair-5-1.svg": 366,
	"./hair-5-2.svg": 367,
	"./hair-5-3.svg": 368,
	"./hair-5-4.svg": 369,
	"./hair-5-5.svg": 370,
	"./hair-5-6.svg": 371,
	"./hair-5-7.svg": 372,
	"./hair-6-0.svg": 373,
	"./hair-6-1.svg": 374,
	"./hair-6-2.svg": 375,
	"./hair-6-3.svg": 376,
	"./hair-6-4.svg": 377,
	"./hair-6-5.svg": 378,
	"./hair-6-6.svg": 379,
	"./hair-6-7.svg": 380,
	"./hair-7-0.svg": 381,
	"./hair-7-1.svg": 382,
	"./hair-7-2.svg": 383,
	"./hair-7-3.svg": 384,
	"./hair-7-4.svg": 385,
	"./hair-7-5.svg": 386,
	"./hair-7-6.svg": 387,
	"./hair-7-7.svg": 388,
	"./hair-8-0.svg": 389,
	"./hair-8-1.svg": 390,
	"./hair-8-2.svg": 391,
	"./hair-8-3.svg": 392,
	"./hair-8-4.svg": 393,
	"./hair-8-5.svg": 394,
	"./hair-8-6.svg": 395,
	"./hair-8-7.svg": 396,
	"./hair-9-0.svg": 397,
	"./hair-9-1.svg": 398,
	"./hair-9-2.svg": 399,
	"./hair-9-3.svg": 400,
	"./hair-9-4.svg": 401,
	"./hair-9-5.svg": 402,
	"./hair-9-6.svg": 403,
	"./hair-9-7.svg": 404,
	"./head-0.svg": 405,
	"./head-1.svg": 406,
	"./head-2.svg": 407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 305;